import { render, staticRenderFns } from "./zhifu.vue?vue&type=template&id=69b678d2&"
import script from "./zhifu.vue?vue&type=script&lang=js&"
export * from "./zhifu.vue?vue&type=script&lang=js&"
import style0 from "./zhifu.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports